import { render, staticRenderFns } from "./NewMenu.vue?vue&type=template&id=78722a33&"
import script from "./NewMenu.vue?vue&type=script&lang=js&"
export * from "./NewMenu.vue?vue&type=script&lang=js&"
import style0 from "./NewMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports